import React from 'react'
import Drawer from '@mui/material/Drawer'
import moment from 'moment'
import 'moment/locale/es-mx'

import { Icons } from '../components/Icons'
import IconButton from '@mui/material/IconButton'
import iconClose from '../assets/icons/close.svg'

moment.locale('es-mx')

export default function Notifications(props) {
  const {
    anchorEl,
    handleClose,
    notifications,
  } = props

  return (
    <Drawer anchor='right' open={anchorEl} onClose={handleClose} className='paperWrap app'>
      <div className='notificationsWrap'>
        <IconButton onClick={handleClose} className='closeDrawer'><Icons path={iconClose} /></IconButton>
        <header className="rowS"><h2>Notificaciones</h2></header>
        <ul>
          {notifications.map((notification, index) => (
            <li key={index} className='notifyItem'>
              <a href={notification.click_action}>
                <div className='leftContent'>
                  {!notification.isChecked && <span className='alertBallon'></span>}
                  <figure className='ratioImgBox ratioPortrait'>
                    {notification.image_url ? (
                      <img src={notification.image_url} alt='' className='' />
                    ) : (
                      <img src='https://images2-mega.cdn.mdstrm.com/ott/placeholders-imgs/notify-mega-go.jpg' alt='logo-mega' className='' />
                    )}
                  </figure>
                </div>
                <div className='centerContent'>
                  <h5>{notification.title}</h5>
                  <p>{notification.body}</p>
                  <span>{notification.time_ago}</span>
                </div>
              </a>
            </li>
          ))}
        </ul>
      </div>
    </Drawer>
  )
}